export default defineNuxtPlugin(() => {
  useCookieConsent().hydrate()
})
